export default "__VITE_PUBLIC_ASSET__6e101f98__"